"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var singleton_1 = require("./singleton");
var EmployeeStore = (function () {
    function EmployeeStore(masterAccountId) {
        var _this = this;
        Object.defineProperty(this, "defaultSearchResultLimit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "employeeTree", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "employeesMap", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "focusedEmployee", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "initialLevel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currentlyBuildingEmployeePeersAndManager", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currentlyBuildingEmployeeTree", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "masterAccountId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "replaceTree", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (newTree) {
                _this.focusedEmployee = null;
                _this.employeesMap.clear();
                _this.employeeTree = newTree;
            }
        });
        Object.defineProperty(this, "reassignTree", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (newTree) {
                _this.employeeTree = newTree;
            }
        });
        Object.defineProperty(this, "pushSubTree", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (subTree, targetEmployee) {
                for (var _i = 0, subTree_1 = subTree; _i < subTree_1.length; _i++) {
                    var employee = subTree_1[_i];
                    var employeeFromMap = employee.employeeSourceId ? _this.employeesMap.get(employee.employeeSourceId) : null;
                    if (!employeeFromMap) {
                        targetEmployee.directReports.push(employee);
                        continue;
                    }
                    _this.pushSubTree(employee.directReports, employeeFromMap);
                }
            }
        });
        mobx_1.makeObservable(this);
        this.masterAccountId = masterAccountId;
        this.employeesMap = new Map();
        this.initialLevel = 0;
    }
    Object.defineProperty(EmployeeStore.prototype, "currentlyBuildingTree", {
        get: function () {
            return this.currentlyBuildingEmployeeTree || this.currentlyBuildingEmployeePeersAndManager;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeStore.prototype, "setInitialLevel", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.initialLevel = this.focusedEmployee && this.focusedEmployee.level ? this.focusedEmployee.level : 0;
        }
    });
    Object.defineProperty(EmployeeStore.prototype, "mapEmployees", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (employees) {
            var _this = this;
            (employees || []).forEach(function (employee) {
                if (!employee.employeeSourceId) {
                    return;
                }
                var existingEmployee = _this.employeesMap.get(employee.employeeSourceId);
                if (!existingEmployee) {
                    _this.employeesMap.set(employee.employeeSourceId, employee);
                }
                _this.mapEmployees(employee.directReports);
            });
        }
    });
    Object.defineProperty(EmployeeStore.prototype, "buildEmployeeSubTree", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (employee, requestedDepth) {
            return __awaiter(this, void 0, void 0, function () {
                var employeeSubTree;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!employee.employeeSourceId) {
                                return [2];
                            }
                            return [4, singleton_1.employeeService
                                    .getEmployeeReports(this.masterAccountId, employee.employeeSourceId, requestedDepth)];
                        case 1:
                            employeeSubTree = (_a.sent()) || [];
                            this.pushSubTree(employeeSubTree, employee);
                            return [2];
                    }
                });
            });
        }
    });
    Object.defineProperty(EmployeeStore.prototype, "getEmployee", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (employeeSourceId) {
            return __awaiter(this, void 0, void 0, function () {
                var employee;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.employeesMap.has(employeeSourceId)) {
                                return [2, Promise.resolve()];
                            }
                            return [4, singleton_1.employeeService.getEmployee(this.masterAccountId, employeeSourceId)];
                        case 1:
                            employee = _a.sent();
                            if (employee) {
                                this.replaceTree(employee);
                                this.mapEmployees(this.employeeTree ? [this.employeeTree] : []);
                            }
                            return [2];
                    }
                });
            });
        }
    });
    Object.defineProperty(EmployeeStore.prototype, "focusOnEmployee", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (employeeSourceId) {
            if (this.focusedEmployee) {
                this.focusedEmployee.unfocus();
            }
            this.focusedEmployee = employeeSourceId ? this.employeesMap.get(employeeSourceId) || null : null;
            if (this.focusedEmployee && this.focusedEmployee.focus) {
                this.focusedEmployee.focus();
            }
        }
    });
    Object.defineProperty(EmployeeStore.prototype, "ensureEmployeePeersAndManager", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var peersDepth, masterAccountId, results, peers, manager;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.currentlyBuildingEmployeePeersAndManager = true;
                            if (!this.focusedEmployee ||
                                this.focusedEmployee.managerSourceId == null ||
                                this.employeesMap.has(this.focusedEmployee.managerSourceId)) {
                                this.currentlyBuildingEmployeePeersAndManager = false;
                                return [2, Promise.resolve()];
                            }
                            peersDepth = 1;
                            masterAccountId = this.masterAccountId;
                            return [4, Promise.all([
                                    singleton_1.employeeService.getEmployeeReports(masterAccountId, this.focusedEmployee.managerSourceId, peersDepth),
                                    singleton_1.employeeService.getEmployee(masterAccountId, this.focusedEmployee.managerSourceId)
                                ])];
                        case 1:
                            results = _a.sent();
                            peers = results[0] || [];
                            manager = results[1];
                            if (!!manager) {
                                manager.directReports =
                                    peers.filter(function (peer) { return !_this.focusedEmployee ||
                                        peer.employeeSourceId !== _this.focusedEmployee.employeeSourceId; });
                                if (this.employeeTree) {
                                    manager.directReports.push(this.employeeTree);
                                    this.reassignTree(manager);
                                    this.mapEmployees([this.employeeTree]);
                                }
                            }
                            this.currentlyBuildingEmployeePeersAndManager = false;
                            return [2];
                    }
                });
            });
        }
    });
    Object.defineProperty(EmployeeStore.prototype, "ensureEmployeeTree", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (requestedDepth) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.currentlyBuildingEmployeeTree = true;
                            if (!this.focusedEmployee || this.focusedEmployee.targetDepthHasBeenEnsured) {
                                this.currentlyBuildingEmployeeTree = false;
                                return [2, Promise.resolve()];
                            }
                            return [4, this.buildEmployeeSubTree(this.focusedEmployee, requestedDepth)];
                        case 1:
                            _a.sent();
                            this.focusedEmployee.directReportsCount = this.focusedEmployee.directReports.length;
                            this.focusedEmployee.targetDepthHasBeenEnsured = true;
                            this.mapEmployees([this.focusedEmployee]);
                            this.currentlyBuildingEmployeeTree = false;
                            return [2];
                    }
                });
            });
        }
    });
    Object.defineProperty(EmployeeStore.prototype, "getSuggestedEmployees", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (searchText, resultLimit) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, singleton_1.employeeService.getSuggestedEmployees(this.masterAccountId, searchText, resultLimit)];
                        case 1: return [2, _a.sent()];
                    }
                });
            });
        }
    });
    Object.defineProperty(EmployeeStore.prototype, "getEmployeesFromMapAtLevel", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (level, employeesForEachLevel) {
            var employees = employeesForEachLevel.get(level);
            if (!employees) {
                employees = [];
                employeesForEachLevel.set(level, employees);
            }
            return employees;
        }
    });
    Object.defineProperty(EmployeeStore.prototype, "getReportsAtEachLevel", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (employee, employeesForEachLevel, currentLevel, targetLevel) {
            if (!employee) {
                return;
            }
            var directReportLevel = (employee.level || 0) + 1;
            var employees = this.getEmployeesFromMapAtLevel(directReportLevel, employeesForEachLevel);
            for (var _i = 0, _a = employee.directReports; _i < _a.length; _i++) {
                var directReport = _a[_i];
                if (currentLevel > targetLevel) {
                    continue;
                }
                employees.push(directReport);
                this.getReportsAtEachLevel(directReport, employeesForEachLevel, currentLevel + 1, targetLevel);
            }
            employeesForEachLevel.set(directReportLevel, employees);
        }
    });
    Object.defineProperty(EmployeeStore.prototype, "getEmployeesForEachLevel", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (numberOfLevels) {
            if (!this.focusedEmployee) {
                return null;
            }
            var employeesForEachLevel = new Map();
            var manager = this.focusedEmployee.managerSourceId ?
                this.employeesMap.get(this.focusedEmployee.managerSourceId) : undefined;
            if (manager === undefined) {
                employeesForEachLevel.set(this.focusedEmployee.level || 0, [this.focusedEmployee]);
                this.getReportsAtEachLevel(this.focusedEmployee, employeesForEachLevel, 1, numberOfLevels - 1);
            }
            else {
                employeesForEachLevel.set(manager.level || 0, []);
                this.getReportsAtEachLevel(manager, employeesForEachLevel, 1, 1);
                this.getReportsAtEachLevel(this.focusedEmployee, employeesForEachLevel, 2, numberOfLevels - 1);
            }
            return employeesForEachLevel;
        }
    });
    Object.defineProperty(EmployeeStore.prototype, "isFirstLevelEmployee", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (employee) {
            if (!employee) {
                return false;
            }
            if (!employee.managerSourceId) {
                return true;
            }
            var manager = this.employeesMap.get(employee.managerSourceId);
            return manager === undefined;
        }
    });
    Object.defineProperty(EmployeeStore.prototype, "getLevelClasses", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (currentLevel, displayedLevel) {
            var level = this.focusedEmployee ? this.focusedEmployee.level || 0 : 0;
            if (currentLevel === level) {
                return 'root-level';
            }
            else if (currentLevel === level + 1) {
                return 'second-level';
            }
            else if (currentLevel === level + 2) {
                return 'third-level';
            }
            else if (currentLevel > level + 2 && currentLevel < displayedLevel) {
                return 'after';
            }
            else if (currentLevel >= displayedLevel) {
                return 'after hidden';
            }
            else {
                return 'before hidden';
            }
        }
    });
    Object.defineProperty(EmployeeStore.prototype, "getSearchSuggestionText", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (employee) {
            return employee.employeeSourceId + " - " + employee.displayName;
        }
    });
    __decorate([
        mobx_1.observable
    ], EmployeeStore.prototype, "defaultSearchResultLimit", void 0);
    __decorate([
        mobx_1.observable
    ], EmployeeStore.prototype, "employeeTree", void 0);
    __decorate([
        mobx_1.observable
    ], EmployeeStore.prototype, "employeesMap", void 0);
    __decorate([
        mobx_1.observable
    ], EmployeeStore.prototype, "focusedEmployee", void 0);
    __decorate([
        mobx_1.observable
    ], EmployeeStore.prototype, "initialLevel", void 0);
    __decorate([
        mobx_1.observable
    ], EmployeeStore.prototype, "currentlyBuildingEmployeePeersAndManager", void 0);
    __decorate([
        mobx_1.observable
    ], EmployeeStore.prototype, "currentlyBuildingEmployeeTree", void 0);
    __decorate([
        mobx_1.observable
    ], EmployeeStore.prototype, "masterAccountId", void 0);
    __decorate([
        mobx_1.computed
    ], EmployeeStore.prototype, "currentlyBuildingTree", null);
    __decorate([
        mobx_1.action
    ], EmployeeStore.prototype, "setInitialLevel", null);
    __decorate([
        mobx_1.action
    ], EmployeeStore.prototype, "mapEmployees", null);
    __decorate([
        mobx_1.action
    ], EmployeeStore.prototype, "replaceTree", void 0);
    __decorate([
        mobx_1.action
    ], EmployeeStore.prototype, "reassignTree", void 0);
    __decorate([
        mobx_1.action
    ], EmployeeStore.prototype, "pushSubTree", void 0);
    __decorate([
        mobx_1.action
    ], EmployeeStore.prototype, "buildEmployeeSubTree", null);
    __decorate([
        mobx_1.action
    ], EmployeeStore.prototype, "getEmployee", null);
    __decorate([
        mobx_1.action
    ], EmployeeStore.prototype, "focusOnEmployee", null);
    __decorate([
        mobx_1.action
    ], EmployeeStore.prototype, "ensureEmployeePeersAndManager", null);
    __decorate([
        mobx_1.action
    ], EmployeeStore.prototype, "ensureEmployeeTree", null);
    return EmployeeStore;
}());
exports.EmployeeStore = EmployeeStore;
